import React from 'react';
import PropTypes from 'prop-types';
import { normalizeTagSlugs } from '../../../utils/catalogTags';
import './CatalogTagPicker.css';

const CatalogTagPicker = ({
  catalogTags = [],
  value = [],
  onChange,
  disabled = false,
  ariaLabel = 'Tags',
}) => {
  const selected = normalizeTagSlugs(value);
  const activeTags = (catalogTags || []).filter((tag) => tag?.is_active !== false && tag?.slug);

  if (activeTags.length === 0) {
    return (
      <p className="catalog-tag-picker-empty">
        No tags configured yet. An admin can add tags under Admin → Catalog tags.
      </p>
    );
  }

  const toggle = (slug) => {
    if (disabled) return;
    const next = selected.includes(slug)
      ? selected.filter((item) => item !== slug)
      : [...selected, slug];
    onChange?.(next);
  };

  return (
    <div className="catalog-tag-picker" role="group" aria-label={ariaLabel}>
      {activeTags.map((tag) => {
        const slug = String(tag.slug).trim().toLowerCase();
        const isSelected = selected.includes(slug);
        return (
          <button
            key={slug}
            type="button"
            className={`catalog-tag-chip${isSelected ? ' is-selected' : ''}`}
            aria-pressed={isSelected}
            disabled={disabled}
            onClick={() => toggle(slug)}
          >
            {tag.label || slug}
          </button>
        );
      })}
    </div>
  );
};

CatalogTagPicker.propTypes = {
  catalogTags: PropTypes.arrayOf(PropTypes.shape({
    slug: PropTypes.string,
    label: PropTypes.string,
    is_active: PropTypes.bool,
  })),
  value: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  ariaLabel: PropTypes.string,
};

export default CatalogTagPicker;
